var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-30 container"},[_vm._v(" 页面内容待定。。。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }